export default __webpack_public_path__ + "static/media/per-monster.2fb7f5ca.svg";